<template>
  <v-container>
    <v-form ref="form" v-model="valid" :lazy-validation="false">
      <v-row>
        <v-col cols="12" offset-md="2" md="6">
          <div>
            <h1 v-if="isUpdating">Update Dealer Infomation</h1>
            <h1 v-else>Create New Dealer</h1>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col offset-md="2" cols="6" md="4">
          <v-text-field
            v-model="formData.firstName"
            :rules="validation.firstName"
            label="ชื่อ"
            persistent-hint
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="4">
          <v-text-field
            v-model="formData.lastName"
            :rules="validation.lastName"
            label="นามสกุล"
            persistent-hint
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" offset-md="2" md="4">
          <v-text-field
            label="ชื่อเล่น"
            v-model="formData.nickName"
            :rules="validation.nickName"
            persistent-hint
            outlined></v-text-field>
        </v-col>
        <v-col cols="6" md="4">
          <v-menu
            v-model="activeDateInput"
            :close-on-content-click="false"
            max-width="290">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedDateFormatted"
                clearable
                label="วันเกิด"
                :rules="validation.dob"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                @click:clear="date = null"
              />
            </template>
            <v-date-picker
              v-model="formData.dob"
              @change="activeDateInput = false"
            />
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-text-field
            label="E-mail"
            v-model="formData.email"
            :rules="validation.email"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-select
            label="เพศ"
            :items="genders"
            v-model="formData.gender"
            :rules="validation.gender"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-text-field
            v-model="formData.oldDealerId"
            label="รหัสตัวแทนเดิม (กรณีเป็นตัวแทนอยู่แล้ว)"
            :rules="validation.oldDealerId"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-text-field
            v-model="formData.teamParentId"
            label="รหัสตัวแทนแม่ทีม (ตัวแทนที่ท่านสมัครด้วย)"
            :rules="validation.teamParentId"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-text-field
            v-model="formData.classTeam"
            label="สายทีม"
            :rules="validation.classTeam"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-text-field
            v-model="formData.classTeamId"
            label="รหัสสายทีม"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-select
            v-model="formData.sellerStatus"
            label="สถานะ"
            :items="status"
            :rules="validation.sellerStatus"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-textarea
            v-model="formData.address"
            label="ที่อยู่ที่สามารถติดต่อได้สะดวก"
            :rules="validation.address"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-text-field
            v-model="formData.province"
            label="จังหวัด"
            :rules="validation.province"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-text-field
            v-model="formData.postCode"
            label="รหัสไปรษณีย์"
            :rules="validation.postCode"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-text-field
            v-model="formData.tel"
            label="เบอร์โทรศัพท์ที่ติดต่อได้สะดวก"
            :rules="validation.tel"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-text-field
            v-model="formData.lineId"
            label="LINE ID (ถ้ามี)"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-text-field
            v-model="formData.instagram"
            label="Instagram (ถ้ามี)"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-text-field
            v-model="formData.facebook"
            label="Facebook"
            :rules="validation.facebook"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-text-field
            v-model="formData.facebookPage"
            label="Facebook Fanpage (ถ้ามี)"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-text-field
            v-model="formData.sellArea"
            :rules="validation.sellArea"
            label="พื้นที่ขาย"
            persistent-hint
            outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <v-combobox
            v-model="formData.tags"
            hide-selected
            label="Tags"
            multiple
            outlined
            clearable
            small-chips>
            <template v-slot:selection="{ item, index }">
              <v-chip
                class="mx-1"
                :color="getColor(index)"
                text-color="white"
                small
                label
                close
                @click:close="formData.tags.splice(index, 1)"
              >
                {{ item }}
              </v-chip>
            </template>
          </v-combobox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <div style="margin-bottom: 20px;">
            สำเนาบัตรประชาชน
          </div>
          <div v-if="formData.nationalCardImageUrl !== null">
            <img :src="formData.nationalCardImageUrl" width="300" alt="">
            <v-btn
              x-small
              fab
              class="remove-img-btn"
              color="blue-grey lighten-5"
              @click="removeImage('nationalCardImageUrl')">
                <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </div>
          <div v-else>
            <v-file-input
              outlined
              accept="image/*"
              label="Image"
              dense
              v-model="formData.nationalCardImageUrl"
              @change="(file) => { uploadFile(file, 'nationalCardImageUrl') }"
              truncate-length="15"
            ></v-file-input>
            <v-progress-linear
              v-show="uploadProgress.nationalCardImageUrl !== 0 & uploadProgress.nationalCardImageUrl !== 100"
              :value="uploadProgress.nationalCardImageUrl" />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" md="8">
          <div style="margin-bottom: 20px;">
            รูปถ่ายสำหรับทำบัตรตัวแทน
          </div>
          <div v-if="formData.sellerCardImageUrl !== null">
            <img :src="formData.sellerCardImageUrl" width="300" alt="">
            <v-btn
              x-small
              fab
              class="remove-img-btn"
              color="blue-grey lighten-5"
              @click="removeImage('sellerCardImageUrl')">
                <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </div>
          <div v-else>
            <v-file-input
              outlined
              accept="image/*"
              label="Image"
              dense
              v-model="formData.sellerCardImageUrl"
              @change="(file) => { uploadFile(file, 'sellerCardImageUrl') }"
              truncate-length="15"
            ></v-file-input>
            <v-progress-linear
              v-show="uploadProgress.sellerCardImageUrl !== 0 & uploadProgress.sellerCardImageUrl !== 100"
              :value="uploadProgress.sellerCardImageUrl" />
          </div>
        </v-col>
      </v-row>
      <v-row v-if="!isUpdating">
        <v-col cols="12" offset-md="2" md="8">
          <v-btn block color="primary" :loading="loading" @click="createDealer">Save</v-btn>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="6" offset-md="2" md="4">
          <v-btn block color="primary" :loading="loading" @click="updateDealer">Save</v-btn>
        </v-col>
        <v-col cols="6" md="4">
          <v-btn block color="pink" :loading="loading" @click="confirmRemove">Delete</v-btn>
        </v-col>
      </v-row>
    </v-form>
    <modal-confirm
      :active="modalConfirm"
      :confirm-text="`Confirm`"
      :title="'Confirm delete.'"
      :message="`Confirm delete dealer ${formData.firstName} ${formData.lastName}.`"
      :show-cancel="true"
      @onCancel="() => { modalConfirm = false }"
      @onConfirm="removeDealer" />
  </v-container>
</template>

<script>
import DealerProvider from '@/resources/DealerProvider'
import ModalConfirm from '@/components/ModalConfirm'
import { mapActions } from 'vuex'
import dayjs from 'dayjs'
import storage from '@/utils/js/Firebase'
const dealerService = new DealerProvider()
export default {
  components: { ModalConfirm },
  data: () => ({
    genders: [
      'ชาย', 'หญิง', 'ไม่ระบุ'
    ],
    status: [
      'ตัวแทน Exclusive', 'ตัวแทน VIP', 'ตัวแทนเดิม Stock', 'ตัวแทนเดิม Non-Stock', 'ตัวแทนใหม่ Stock', 'ตัวแทนใหม่ Non-Stock'
    ],
    loading: false,
    image: null,
    modalConfirm: false,
    activeDateInput: false,
    valid: false,
    formData: {
      firstName: '',
      lastName: '',
      address: '',
      nickName: '',
      dob: null,
      email: '',
      gender: 'ไม่ระบุ',
      oldDealerId: '',
      teamParentId: '',
      classTeam: '',
      sellerStatus: 'ตัวแทน Exclusive',
      sellArea: '',
      province: '',
      postCode: '',
      tel: '',
      lineId: '',
      instagram: '',
      classTeamId: '',
      facebook: '',
      facebookPage: '',
      nationalCardImageUrl: null,
      sellerCardImageUrl: null
    },
    uploadProgress: {
      nationalCardImageUrl: 0,
      sellerCardImageUrl: 0
    },
    validation: {
      firstName: [
        v => !!v || 'กรุณากรอก ชื่อ'
      ],
      sellerStatus: [
        v => !!v || 'กรุณาเลือก สถานะ'
      ],
      lastName: [
        v => !!v || 'กรุณากรอก นามสกุล'
      ],
      gender: [
        v => !!v || 'กรุณาระบุ เพศ'
      ],
      nickName: [
        v => !!v || 'กรุณากรอก ชื่อเล่น'
      ],
      dob: [
        v => !!v || 'กรุณากรอก วันเกิด',
        v => v !== null || 'กรุณากรอก วันเกิด'
      ],
      province: [
        v => !!v || 'กรุณากรอก จังหวัด'
      ],
      teamParentId: [
        v => !!v || 'กรุณากรอก รหัสตัวแทนแม่ทีม'
      ],
      postCode: [
        v => !!v || 'กรุณากรอก รหัสไปรษณีย์',
        v => /^[0-9]{5}$/.test(v) || 'รหัสไปรษณีย์ ไม่ถูกต้อง'
      ],
      classTeam: [
        v => !!v || 'กรุณากรอก สายทีม'
      ],
      address: [
        v => !!v || 'กรุณากรอก ที่อยู่ที่สามารถติดต่อได้สะดวก'
      ],
      area: [
        v => !!v || 'กรุณากรอก ที่อยู่ที่สามารถติดต่อได้สะดวก'
      ],
      email: [
        v => !!v || 'กรุณากรอก อีเมล',
        v => /.+@.+/.test(v) || 'อีเมล ไม่ถูกต้อง'
      ],
      facebook: [
        v => !!v || 'กรุณากรอก facebook'
      ],
      sellArea: [
        v => !!v || 'กรุณากรอก facebook'
      ],
      tel: [
        v => !!v || 'กรุณากรอก เบอร์โทรศัพท์',
        v => /^\d{10}$/.test(v) || 'เบอร์โทรศัพท์ ไม่ถูกต้อง'
      ]
    }
  }),
  computed: {
    isUpdating () {
      return this.$route.params.id ? true : false
    },
    computedDateFormatted () {
      return this.formData.dob ? dayjs(this.formData.dob).format('DD MMMM YYYY') : ''
    },
    dealerId () {
      return this.$route.params.id ? this.$route.params.id : 0
    }
  },
  async mounted () {
    this.loading = true
    if (this.isUpdating) {
      await this.getDealer()
    }
    this.loading = false
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Style/setSnackbar'
    }),
    getColor (index) {
      const colors = ['pink', 'cyan', 'purple darken-2', 'red',
        'teal', 'teal accent-2', 'lime', 'orange', 'amber',
        'yellow', 'deep-orange', 'light-green accent-4'
      ]
      return colors[index >= colors.length ? colors.length - 1 : index]
    },
    async uploadFile (file, type) {
      const fileDetail = file.name.split('.')
      const fileType = fileDetail[1] ? `.${fileDetail[1]}` : ''
      const name = `${dayjs().format('x')}${Math.floor(Math.random() * 1000000000)}${fileType}`
      const uploadTask = storage.child(`file/${name}`).put(file)
      await uploadTask.on('state_changed', (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        this.uploadProgress[type] = progress
      }, (error) => {
        // eslint-disable-next-line no-console
        console.log(error)
      }, () => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          this.formData[type] = downloadURL
        })
      })
    },
    removeImage (type) {
      this.formData[type] = null
    },
    confirmRemove () {
      this.modalConfirm = true
    },
    async getDealer () {
      try {
        const { data } = await dealerService.getDealerById(this.dealerId)
        this.formData = {
          ...data,
          dob: dayjs(data.dob).format('YYYY-MM-DD')
        }
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          active: true
        })
      }
    },
    async createDealer () {
      this.$refs.form.validate()
      if (this.valid) {
        try {
          this.loading = true
          const { data } = await dealerService.createDealer(this.formData)
          if (data) {
            this.setSnackbar({
              message: 'Create dealer success.',
              type: 'success',
              active: true
            })
            this.$router.push({ name: 'DealerList'})
          }
        } catch (err) {
          this.setSnackbar({
            message: err.message,
            type: 'pink',
            active: true
          })
        } finally {
          this.loading = false
        }
      }
    },
    async updateDealer () {
      this.$refs.form.validate()
      if (this.valid) {
        try {
          this.loading = true
          const { data } = await dealerService.updateDealer(this.dealerId, this.formData)
          if (data) {
            this.setSnackbar({
              message: 'Update dealer success.',
              type: 'success',
              active: true
            })
            this.$router.push({ name: 'DealerList'})
          }
        } catch (err) {
          this.setSnackbar({
            message: err.message,
            type: 'pink',
            active: true
          })
        } finally {
          this.loading = false
        }
      }
    },
    async removeDealer () {
      try {
        this.loading = true
        const { data } = await dealerService.deleteDealer(this.dealerId)
        if (data) {
          this.setSnackbar({
            message: 'Remove dealer success.',
            type: 'success',
            active: true
          })
          this.$router.push({ name: 'DealerList'})
        }
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          active: true
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="css" scoped>
.img-panel {
  width: fit-content;
  display: flex;
  justify-content: flex-end;
}

.remove-img-btn {
  position: absolute;
  margin-left: -10px !important;
  margin-top: -10px !important;
  color: #e91e63 !important;
}
</style>